// The automatic JSX transform (SWC/Babel) falls back to `createElement`
// imported from the importSource package ROOT for cases jsx() can't express
// (spread-then-key, the styled-components css prop, …). React 19's own
// createElement still resolves defaultProps, so re-exporting react verbatim
// keeps those paths correct — no wrapping needed here.
//
// React's package is CJS, so a bare `export * from 'react'` can't be expanded
// statically — Vite/Rolldown warns "Unable to interop `export *`" and browser
// ESM drops names (notably `createElement`, breaking the transform's css-prop /
// spread-then-key fallback). Enumerate React 19's public surface explicitly.
export {
    Activity,
    Children,
    Component,
    Fragment,
    Profiler,
    PureComponent,
    StrictMode,
    Suspense,
    act,
    cache,
    cacheSignal,
    captureOwnerStack,
    cloneElement,
    createContext,
    createElement,
    createRef,
    forwardRef,
    isValidElement,
    lazy,
    memo,
    startTransition,
    unstable_useCacheRefresh,
    use,
    useActionState,
    useCallback,
    useContext,
    useDebugValue,
    useDeferredValue,
    useEffect,
    useEffectEvent,
    useId,
    useImperativeHandle,
    useInsertionEffect,
    useLayoutEffect,
    useMemo,
    useOptimistic,
    useReducer,
    useRef,
    useState,
    useSyncExternalStore,
    useTransition,
    version,
} from 'react';
export { default } from 'react';
